import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-your-annotation',
  templateUrl: './your-annotation.component.html'
})
export class YourAnnotationComponent implements OnInit {
  @Output() myEvent = new EventEmitter<string>();

  constructor(
    public commonDataService: CommonDataService, private graphQlService: GraphqlService) {
  }

  addAnnotationLabel: string;
  yourAnnotationLabel: string;
  seeMyAnnotations: string;
  paragraphId: string = "";
  lineRequired: boolean = false;

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.getParagraphId();
    this.getYourAnnotationLabel();
  }


  getParagraphId() {
    this.commonDataService.currentParagraph.subscribe(data => {
      this.paragraphId = data;

    })
  }

  addAnnotations() {
    this.commonDataService.annotationContent.next(null);
    this.commonDataService.annotationUpdateSource.next("Your Annotation");
    this.commonDataService.rightOverlayOption.next("Add Annotation");
  }
  labelItems: any =[];
  getYourAnnotationLabel() {
    this.graphQlService.getGlobalLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        this.labelItems = labels;
        labels = labels.filter(x => x.key.trim());
        this.addAnnotationLabel = labels.filter(x => x.key == "addAnnotation_header").map(y => y.value);
        this.yourAnnotationLabel = labels.filter(x => x.key == "addAnnotation_body").map(y => y.value);
        this.seeMyAnnotations = labels.filter(x => x.key == "yourAnnotations_viewInline").map(y => y.value);
      }
    });
  }

  myAnnotation() {
    this.commonDataService.annotationWithinContent.next(this.paragraphId);
    this.closeOverlay();
  }

  closeOverlay() {
    this.myEvent.emit();
  }
}
